/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {$SetVisibility, $Sprite, $Button, FC, ButtonProps, $RichText, CanBeSignals} from '@gongxigames/framework/core/fragments/BuilderY';
import {Rectangle} from 'pixi.js';

const BUTTON_STATES: Record<string, string> = {disabled:'disabled', focused: 'hovered', pressed: 'pressed', normal: 'normal'};

type BuyFeatureButtonOptions = CanBeSignals<{
    textAlpha: number;
}> & Omit<ButtonProps, 'children' | 'hitArea'>;

export const $BuyFeatureButton: FC<BuyFeatureButtonOptions> = (props) => {
    const {action, responsive} = props;
    const hitArea = new Rectangle(-350/2, -350/2, 350, 350);

    const stateComponents = Object.keys(BUTTON_STATES).map(state =>{
        return <$Sprite name={state} anchor={0.5} texture={`btn_bf_${BUTTON_STATES[state]}`}>
            <$RichText
                alpha={props.textAlpha}
                localeID='buyFeature'
                name={`btn_bf_${state}`}
                style='BuyFeatureButtonStyle'
                maxWidth={314}
                maxHeight={314}
            />
        </$Sprite>;
    });

    return <$Button
        {...props}
        name='buyFeatureBtn'
        hitArea={hitArea}
        action={action}
        responsive={responsive}
    >{(props) => {
            return <$SetVisibility selector={props.selector}>
                {stateComponents}
            </$SetVisibility>;
        }}</$Button>;
};
